import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from './index';

const initialState: any = {
    settings: null,
};

const companyRegistrationSlice = createSlice({
    name: 'companyRegistration',
    initialState,
    reducers: {
        setCompanyRegistrationSlice(state, action: PayloadAction<any>) {
            state.settings = action.payload;
        },
    },
});

export const getCompanyRegistrationSettings = () => {
    return async (dispatch: AppDispatch) => {
        try {
            const response = await fetch('/company-registration-settings.json');
            const data = await response.json();
            dispatch(companyRegistrationSlice.actions.setCompanyRegistrationSlice(data));
        } catch (err) {
            console.log('error from companyRegistration', err);
        }
    };
};

export default companyRegistrationSlice.reducer;
export const { setCompanyRegistrationSlice } = companyRegistrationSlice.actions;
